import * as React from 'react';
import { StyleSheet } from 'react-native';
import Webcam from 'react-webcam';
import { Button } from 'react-native-elements';

import { Text, View } from '../components/Themed';
import Container from '../components/Container';
import Separator from '../components/Separator';

export default function Picture({ route, navigation }) {
  const [IsCamOn, setIsCamOn] = React.useState(true);
  const name = route.params.name;
  console.log(name);
  
  const webcamRef = React.useRef(null);
  const inputFileRef: React.RefObject<HTMLInputElement> = React.useRef(null)

  const onTakePicture = () => {
    if (webcamRef) {
      const imageSrc = webcamRef.current.getScreenshot();
      setIsCamOn(false);
      navigation.navigate('Preview', { name: name, image: imageSrc });
    }
  };

  function pickPhoto(event: any) {
    if (event.target.files.length > 0) {
      const reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = function () {
        setIsCamOn(false);
        navigation.navigate('Preview', { name: name, image: reader.result as string });
      }
    }
  }

  function pickFile() {
    if (inputFileRef.current !== null) {
      let input: any = inputFileRef.current
      input.click()
    }
  }

  React.useEffect(() => {
    navigation.addListener('focus', () => {
      setIsCamOn(true);
    });
}, [navigation]);

  return (
    <Container>
      <Text style={styles.title}>{name}</Text>
      <Separator />
      {IsCamOn && <Webcam ref={webcamRef} style={{borderRadius: 8, width: "80%", maxWidth: "800px"}} screenshotFormat="image/jpeg" />}
      <Separator />
      <View style={styles.buttons}>
        <Button buttonStyle={styles.button} title="Prendre une photo / Take a picture" onPress={onTakePicture} />
        <Button buttonStyle={styles.button} type="outline" title="Choisir une image / Choose an image" onPress={pickFile} />
        <input hidden ref={inputFileRef} type="file" accept="image/*" onChange={pickPhoto} />
      </View>
    </Container>
  );
}

const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  buttons: {
    display: "flex",
    flexDirection: "row"
  },
  button: {
    margin: 10
  }
});
